import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Pagination, Autoplay } from 'swiper/core';
import { TESTIMONIALS } from '../../constants';
import 'swiper/swiper.scss';
// eslint-disable-next-line import/no-extraneous-dependencies
import 'swiper/components/pagination/pagination.scss';
import '../../assets/styles/testimonials.scss';

const Testimonials = () => {
  SwiperCore.use([Pagination, Autoplay]);
  const clientTestimonials = TESTIMONIALS || [];
  return (
    <section className="hd-testimonials mt-5">
      <Swiper
        spaceBetween={30}
        slidesPerView={1}
        pagination={{
          clickable: true,
        }}
        autoplay
      >
        {clientTestimonials &&
          clientTestimonials.length > 0 &&
          clientTestimonials.map((item, index) => (
            <SwiperSlide key={`hd-testimonial-${index}`}>
              <blockquote>
                <div>{item.content}</div>
                <footer className="text-center mt-4">
                  <cite className="author">
                    <strong>{item.author}</strong>
                  </cite>
                  <br />
                  <cite className="company">{item.company}</cite>
                </footer>
              </blockquote>
            </SwiperSlide>
          ))}
      </Swiper>
    </section>
  );
};

export default Testimonials;
